import React from 'react';
import propTypes from 'prop-types';

export const NextIcon = ({ size, color, variant }) => {
  const sizeInPixel = `${size}px`;
  return (
    <svg
      width={sizeInPixel}
      height={sizeInPixel}
      className={variant}
      fill={color}
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 200.587 200.587"
      enableBackground="new 0 0 200.587 200.587"
      // style="enable-background:new 0 0 200.587 200.587;"
      xmlSpace="preserve"
    >
      <g>
        <g>
          <g>
            <path
              fill={color}
              // style="fill:#010002;"
              d="M85.86,170.938c-3.611,0-7.211-3.443-7.899-4.13c-2.469-1.822-67.787-51.067-74.966-58.231
         c-2.602-2.609-3.06-5.236-2.988-6.979c0.172-4.177,3.396-7.032,3.765-7.34l72.647-60.125c0.795-0.866,4.488-4.484,7.999-4.484
         c1.6,0,5.318,0.727,5.318,7.476v30.993h102.57c0.286-0.047,0.666-0.086,1.12-0.086c1.195,0,7.161,0.455,7.161,9.409v47.635
         c0,6.592-4.67,8.332-7.14,8.332H91.894v28.409C91.894,169.75,88.115,170.938,85.86,170.938z M85.86,165.194v2.87l0.007-2.87
         H85.86z M83.874,35.572c-0.923,0.44-2.452,1.607-3.536,2.756L7.465,98.66c-0.429,0.379-1.668,1.772-1.714,3.207
         c-0.029,0.866,0.401,1.732,1.313,2.648c6.893,6.889,73.993,57.469,74.669,57.977c1.51,1.467,3.303,2.623,4.062,2.698
         c-0.043-0.136,0.358-0.988,0.358-3.371v-34.153h107.269c0.941-0.043,1.421-0.909,1.421-2.591V77.441
         c0-1.106-0.136-3.658-1.417-3.658l-0.361,0.093l-0.483-0.011H83.992V37.129C83.992,36.399,83.938,35.901,83.874,35.572z"
            />
          </g>
        </g>
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
};
NextIcon.propTypes = {
  size: propTypes.number,
  color: propTypes.string,
  variant: propTypes.string,
};
NextIcon.defaultProps = {
  size: 18,
  color: 'black',
  varient: '',
};
